import axios from "axios";
import store from "@/store";
import router from "@/router";

import { isTokenExpired } from "./jwt-helpers";

axios.interceptors.request.use(async config => {
  let token = store.getters["auth/getToken"];
  let refreshToken = store.getters["auth/getRefreshToken"];
  let isLoggedIn = store.getters["auth/isLoggedIn"];

  if (!isLoggedIn) {
    return config;
  }

  if (config.params && config.params.token) {
    token = config.params.token;
  }

  if (!config.headers["X-SkipVerifyToken"] && isTokenExpired(token)) {
    try {
      const { data } = await store.dispatch("auth/refreshToken");

      token = data.token;
    } catch (error) {
      router.push("/login");
    }
  }

  config.headers["Authorization"] = `bearer ${token}`;

  if (config.headers["X-RefreshToken"]) {
    config.headers["Authorization"] = `bearer ${refreshToken}`;
  }

  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    const banned = error?.response?.data?.data?.banned ?? false;

    if (error.response.status === 401 && banned) {
      store.dispatch("auth/logout").then(() => {
        router.push("/login");
      });
    }

    throw error;
  }
);
